// Depends
import { group } from '@/helpers/routes'
import { routes as professional } from './loading-page'

export default [
  ...group('/professional', [
    ...professional
  ])
]



// WEBPACK FOOTER //
// ./src/app/professional/routes.js